import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import moment from "moment"


import {
  cloneDeep, orderBy
} from 'lodash';


import * as timelineEventsActions from 'redux/modules/timelineEvents';


import * as Table from 'reactabular-table';
import * as search from 'searchtabular';
import * as sort from 'sortabular';
import * as resolve from 'table-resolver';

import { Tooltip, OverlayTrigger, Button, Col, Panel, Row } from 'react-bootstrap';

import VisibilityToggles from 'react-visibility-toggles';


import {
  TimelinePaginator, PrimaryControls, paginate
} from '../tableHelpers';

import i18next from 'i18next';


const CHUNK_INDEX = 1000

import { ExportCSVFormTimeEvents } from 'components';

import _ from 'underscore'

import DoubleScrollbar from 'react-double-scrollbar'

var Datetime = require('react-datetime');

import { translate } from 'react-i18next';

@translate(['common'])
@connect(state => ({
  user: state.auth.user,
  data: state.timelineEvents.data,
  error: state.timelineEvents.error,
  count: state.timelineEvents.count,
  begin_date: state.timelineEvents.begin_date,
  end_date: state.timelineEvents.end_date,
}))
export default class TimelineEventsTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //rows: this.props.data, // initial rows
      searchColumn: 'all',
      query: {}, // search query
      sortingColumns: null, // reference to the sorting columns
      columns: this.getColumns(), // initial columns
      pagination: { // initial pagination settings
        page: 1,
        perPage: 10
      },
      begin_date: null,
      end_date: null,
      chunkIndex:0,
    };

    this.onRow = this.onRow.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.onColumnChange = this.onColumnChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onPerPage = this.onPerPage.bind(this);
    this.onToggleColumn = this.onToggleColumn.bind(this);
    this.filterByDate = this.filterByDate.bind(this);
    this.changeChunkIndex = this.changeChunkIndex.bind(this);
  }


  filterByDate() {
    const {begin_date, end_date} = this.state
    if( !begin_date || !end_date ) {
      return
    }

    this.changeChunkIndex(0, true, false)
  }


  componentDidMount(){

    this.changeChunkIndex(0, true, false)

  }

  
  
  changeChunkIndex(index, action=true, concat=true) {
      if( action == true ) {
        var begin_date = this.state.begin_date ? this.state.begin_date.unix() : null
        var end_date   = this.state.end_date   ? this.state.end_date.unix()   : null
      
        this.props.dispatch(timelineEventsActions.load(this.props.params, begin_date, end_date, false, index, concat)).then(()=>{

          this.setState({
            pagination:{
              ...this.state.pagination,
              page:1
            }
          })

        })
      }
  }

  getColumns() {

    const {t} = this.props

    const sortable = sort.sort({
      getSortingColumns: () => this.state.sortingColumns || [],
      onSort: selectedColumn => {
        this.setState({
          sortingColumns: sort.byColumns({ // sort.byColumn would work too
            sortingColumns: this.state.sortingColumns,
            selectedColumn
          })
        });
      }
    });

    const sortableHeader = sortHeader(sortable, () => this.state.sortingColumns);


    var columns = [
      {
        property: 'Numero_Client',
        header: {
          label: t("timelineEvents.num_install_gest"),
          props: {
            className: "",
            width: '500'
          }
        },
        visible: true
      },


      {
        property: 'Numero_Exploitant',
        header: {
          label: t("timelineEvents.num_install_prest"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        visible: true
      },

      {
        property: 'Gestionnaire',
        header: {
          label: t("timelineEvents.gest"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },

        visible: true
      },


      {
        property: 'Direction_Territoriale',
        header: {
          label: t("timelineEvents.compl_addr2"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        visible: true
      },
      {
        property: 'Groupe_HP',
        header: {
          label: t("timelineEvents.program"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        visible: true
      },

      {
        property: 'Exploitant',
        header: {
          label: t("timelineEvents.prest"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        visible: true

      },

      {
        property: 'Adresse',
        header: {
          label: t("timelineEvents.addr_install"),
          //formatters: [sortableHeader],  
          props: {
            className: ""
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {

            const tooltip1 = (
              <Tooltip id="tooltip"><strong>{value}</strong></Tooltip>
            );

            var content =
              <div>
                <span>{value.substring(0, 15)}...&nbsp;</span>
                <OverlayTrigger placement="right" overlay={tooltip1}>
                  <i className="fa fa-home" aria-hidden="true"></i>
                </OverlayTrigger>
              </div>



            return <div>{content}</div>

          }
          ]
        },
        visible: true
      },

      {
        property: 'Repere',
        header: {
          label: t("timelineEvents.addr_comp1"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        visible: true
      },

      {
        property: 'Ville',
        header: {
          label: t("main.city"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        visible: true
      },

      {

        property: 'Code_Postal',
        header: {
          label: t("main.postal_code"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        }, visible: true
      },


      {
        property: 'Date_debut',
        header: {
          label: t("timelineEvents.start_event"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
            //return value
            return !value ? t("main.non_renseigne") :moment(value).format('DD-MM-YYYY HH:mm:ss')

          }, search.highlightCell


          ]
        },

        visible: true
      },

      {
        property: 'Date_fin',
        header: {
          label:t("timelineEvents.end_event"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
            return !value ? t("main.non_renseigne") :moment(value).format('DD-MM-YYYY HH:mm:ss')
            //return value
            //return !value ? 'Non renseigné':moment(value).format('YYYY-MM-DD HH:mm:ss')

          }, search.highlightCell


          ]
        },
        visible: true
      },


      {
        property: 'Date_Intervention',
        header: {
          label: t("timelineEvents.arrive_tech"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
            /*
            if( value ) {
              var [date_debut, date_fin, code_fin] = value.split('%%%%')
              return <div style={{width:'170px'}}>Début : {date_debut}<br/> Fin : {date_fin}<br/> Code fin : {code_fin}</div> 
            } else {
              return ''
            } */

            return value

          },


          ]
        },
        visible: true
      },



      {
        property: 'Temps_dimmobilisation',
        header: {
          label: t("timelineEvents.freeze_time"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        visible: true
      },

      {
        property: 'Description',
        header: {
          label: t("timelineEvents.event_cause"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
            //var title =  t('sts_infos.'+[rowData.call_type,'', rowData.call_code_sync9, rowData.call_code_sync7].join('_'))

            var tkey = 'sts_infos.'+rowData.call_reason.split(' ').join('')

		      	var traduc = i18next.exists(tkey) ? t(tkey) : rowData.call_reason

            return traduc

          },


          ]
        },
        visible: true
      },


      {
        property: 'Vandalisme',
        header: {
          label: t("timelineEvents.vandalisme"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        visible: true
      },


      {
        property: 'Fin_Intervention',
        header: {
          label: t("timelineEvents.depart_tech"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {
            /*
            if( value ) {
              var [date_debut, date_fin, code_fin] = value.split('%%%%')
              return <div style={{width:'170px'}}>Début : {date_debut}<br/> Fin : {date_fin}<br/> Code fin : {code_fin}</div> 
            } else {
              return ''
            } */

            return value

          },


          ]
        },
        visible: true
      },

      /*
      {
        property: 'etat_indisponible_periode',
        header: {
          label: 'Période état indisponible',
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        visible: true
      },*/

      {
        property: 'Raison_depart_tech',
        header: {
          label: t("timelineEvents.raison_depart_tech"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        visible: true
      },

      {
        property: 'indispo_infos',
        header: {
          label: t("timelineEvents.indispo_infos"),
          formatters: [sortableHeader],
          props: {
            className: ""
          }
        },
        cell: {
          formatters: [(value, { rowData }) => {

            var rows = value ? value.split(';') : []

            if (rows.length > 0) {

              return <div style={{ width: '200px', maxHeight: '100px', overflowY: 'auto' }}>{rows.map((r) => {
                var [date_debut, date_fin, code_debut] = r.split('%%%%');

                return <div style={{ border: '1px solid grey', 'padding': "5px" }}>
                  {t("main.start")} : {date_debut}<br /> 
                  {t("main.end")} : {date_fin} <br /> 
                  Code : {code_debut}</div>
              })}</div>


            } else {
              return ''
            }


          }]
        },
        visible: true
      }
    ];

    return columns;
  }


  render() {
    const {
      pagination, 
      sortingColumns, searchColumn, query,
      chunkIndex
    } = this.state;

    var columns = this.getColumns()

    var {data, t} = this.props

    const cols = columns.filter(column => column.visible);

    const paginated = compose(
      paginate(pagination),
      sort.sorter({ columns: cols, sortingColumns, sort: orderBy }),
      search.highlighter({ columns: cols, matches: search.matches, query }),
      search.multipleColumns({ columns: cols, query }),
      resolve.resolve({
        columns: cols,
        method: ({ rowData, column }) => resolve.byFunction('cell.resolve')({
          rowData: resolve.nested({ rowData, column }),
          column
        })
      })
    )(data);

    const notPaginated = compose(
      sort.sorter({ columns: cols, sortingColumns, sort: orderBy }),
      search.multipleColumns({ columns: cols, query }),
      resolve.resolve({
        columns: cols,
        method: ({ rowData, column }) => resolve.byFunction('cell.resolve')({
          rowData: resolve.nested({ rowData, column }),
          column
        })
      })
    )(data);

    
    return (
      <div>
        <Row>
          <Col xs={12} md={3}>
            {t("timelineEvents.start_date")} :
            <Datetime style={{ 'width': '120px' }} locale={i18next.language}
              value={this.state.begin_date}
              onChange={(date) => this.setState({ begin_date: date })} ref="begin_date"
            />
           
          </Col>

          <Col xs={12} md={3}>

            {t("timelineEvents.end_date")} :
            <Datetime style={{ 'width': '120px' }} locale={i18next.language}
              value={this.state.end_date}
              onChange={(date) => this.setState({ end_date: date })} ref="end_date"
            />

          </Col>
          <Col xs={12} md={3}>
            <br/>
            <Button disabled={!this.state.end_date||!this.state.begin_date} bsStyle="primary" bsSize="small" onClick={() => this.filterByDate()}>
              <span>&nbsp;{t("main.filter_by_date")}</span>
            </Button>
          </Col>

        </Row>

        <br />

        {/*
        <Row>
          <Col xs={12} md={6}>
            <Panel collapsible header="Affichage">
              
                <VisibilityToggles
                  columns={columns}
                  onToggleColumn={this.onToggleColumn}
                />
              
              
            </Panel>
                
           </Col>
         </Row>*/}
        <Row>
          <Col xs={12} md={6}>
            <ExportCSVFormTimeEvents
              urlParams={this.props.urlParams}
              rows={notPaginated}
              {...{
                chunkIndex, 
                count:this.props.count, 
                params:this.props.params, 
                changeChunkIndex:this.changeChunkIndex
              }}
            />
          </Col>
        </Row>

        <br />
        <br />


        <Row>
          <Col xs={12} md={12}>
            <PrimaryControls
              className="controls"
              perPage={pagination.perPage}
              column={searchColumn}
              query={query}
              columns={cols}
              rows={data}
              onPerPage={this.onPerPage}
              onColumnChange={this.onColumnChange}
              onSearch={this.onSearch}
              t={t}
            />
          </Col>
          <br />

        </Row>

        <Row>
          <Col xs={12} style={{/*position:'absolute', left:'-150px'*/ }}>


            <div className="table-responsive" id="tableEvents">

              
              {(this.props.begin_date && this.props.end_date) && (
                <div>
                  <br/>
                  <b>{t("main.du")} {moment.unix(this.props.begin_date).format('DD/MM/YYYY HH:mm')} {t("main.au")} {moment.unix(this.props.end_date).format('DD/MM/YYYY HH:mm')}</b>
                  {"   "}
                  <Button bsStyle="danger" bsSize="sm"
                    onClick={()=>this.setState({begin_date:null, end_date:null}, ()=>this.changeChunkIndex(0, true, false))}>                                        
                      {t("main.delete_filter")}
                  </Button>
                </div>
                )
              }
              <DoubleScrollbar style={{ "position": 'sticky' }}>
                <Table.Provider
                  className="table table-striped"
                  columns={cols}
                  style={{ overflowX: 'auto'/*, display:'block' */ }}
                  ref="table"
                >
                  <Table.Header>
                    <search.Columns query={query} columns={cols} onChange={this.onSearch} />
                  </Table.Header>

                  <Table.Body onRow={this.onRow} rows={paginated.rows} rowKey="id" />

                  {/*<CustomFooter columns={cols} rows={paginated.rows} />*/}
                </Table.Provider>

              </DoubleScrollbar>

            </div>

            <div className="controls">
              {
                <TimelinePaginator
                  pagination={pagination}
                  pages={paginated.amount}
                  onSelect={this.onSelect}
                  timelineEvents={true}
                  t={t}

                  chunkOptions={{
                    changeChunkIndex : this.changeChunkIndex,
                    chunkIndex
                  }}
                  count={this.props.count}
                />
              }
            </div>

          </Col>
        </Row>

      </div>

    );
  }
  onRow(row, { rowIndex }) {
    return {
      onClick: () => this.onRowSelected(row)
    };
  }
  onRowSelected(row) {

  }
  onColumnChange(searchColumn) {
    this.setState({
      searchColumn
    });
  }
  onSearch(query) {
    this.setState({
      query
    });
  }
  

  onSelect(page=1) {
    const pages = Math.ceil(
      this.props.data.length / this.state.pagination.perPage
    );

    this.setState({
      pagination: {
        ...this.state.pagination,
        page/*: Math.min(Math.max(page, 1), pages)*/
      }
    });

    
  }
  onPerPage(value) {
    this.setState({
      pagination: {
        ...this.state.pagination,
        perPage: parseInt(value, 10)
      }
    });
  }

  onToggleColumn(columnIndex) {
    const columns = cloneDeep(this.state.columns);
    const column = columns[columnIndex];
    column.visible = !column.visible;
    const query = cloneDeep(this.state.query);
    delete query[column.property];
    this.setState({ columns, query });
  }
}

const CustomFooter = ({ columns, rows }) => {
  return (
    <tfoot>
      <tr>
        {columns.map((column, i) =>
          <td key={`footer-${i}`}>{column.footer ? column.footer(rows) : null}</td>
        )}
      </tr>
    </tfoot>
  );
}

function sortHeader(sortable, getSortingColumns) {
  return (value, { columnIndex }) => {
    const sortingColumns = getSortingColumns() || [];

    return (
      <div style={{ display: 'inline' }}>
        <span className="value">{value}</span>
        {React.createElement(
          'span',
          sortable(
            value,
            {
              columnIndex
            },
            {
              style: { float: 'right' }
            }
          )
        )}
        {sortingColumns[columnIndex] &&
          <span className="sort-order" style={{ marginLeft: '0.5em', float: 'right' }}>
            {sortingColumns[columnIndex].position + 1}
          </span>
        }
      </div>
    );
  };
}

/*
class FixedWidthHeader extends React.Component {
  constructor(props) {
    super(props);

    this.widthSet = false;
    this.state = {
      style: {}
    };
  }
  componentDidUpdate() {
    if (this.widthSet) {
      return;
    }

    const width = this.refs.header.clientWidth;



    // Wait till width is available and set then
    if (width) {
      this.widthSet = true;

      this.setState({ // eslint-disable-line react/no-did-update-set-state
        style: { width }
      });
    }
  }
  render() {
    return (
      <th style={this.state.style} ref="header">{this.props.children}</th>
    );
  }
}

*/
